import React from 'react'
import { useTranslation } from 'react-i18next'
import { PhoneUtils } from '@pbt/pbt-ui-components'

import Link from '~/components/common/link/Link'
import MetadataList from '~/components/dashboard/soapV2/summary/patient-details/MetadataList'
import type { Contact } from '~/types'

const ContactCommunication = ({ contact }: { contact: Contact }) => {
  const { t } = useTranslation(['Common'])

  return (
    <MetadataList
      items={[
        {
          value: (
            <Link to={`/admin/general/contacts/${contact.id}`}>
              {contact?.name}
            </Link>
          ),
        },
        { value: contact?.email || '' },
        { value: PhoneUtils.formatPhoneNumber(contact?.phone) },
      ]}
      prefix={`${t('Common:To')}: `}
    />
  )
}

export default ContactCommunication
